import type { ActivePerformance } from './auth-store'

export interface PerformanceQuery {
  tourId?: string
  showId?: string
}

export function buildPerformanceQuery(active: ActivePerformance | null): PerformanceQuery {
  if (!active) return {}
  if (active.kind === 'tour') return { tourId: active.id }
  return { showId: active.id }
}

export function filterRowsByShowIds<T>(
  rows: T[],
  getShowId: (row: T) => string | null | undefined,
  showIds: string[] | null,
): T[] {
  if (!showIds) return rows
  const allowed = new Set(showIds)
  return rows.filter((row) => {
    const id = getShowId(row)
    return id != null && allowed.has(id)
  })
}
